import { render, staticRenderFns } from "./crm-look.vue?vue&type=template&id=8ea7dd28&"
import script from "./crm-look.vue?vue&type=script&lang=js&"
export * from "./crm-look.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports